import * as Yup from 'yup';

export const validation = Yup.object().shape({
	name: Yup.string().nullable().required('Condition name required.'),
	entityTags: Yup.array().required('Channel required.'),
});

export const validationSensor = [validation, undefined];
